// extracted by mini-css-extract-plugin
export default {"drawerContainer":"drawerContainer___IM1or"};